import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ListItem, IconButton, AppBar, Toolbar } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import avatarIcon from "../../assets/images/demo-avatar.png";

/*  Todo : use in future */
// import SettingsIcon from "@mui/icons-material/Settings";
// import HelpIcon from "@mui/icons-material/Help";
import LogoutIcon from "@mui/icons-material/Logout";
import {
  StyledBoxLogOut,
  StyledDrawer,
  StyledList,
  StyledListItemButtonBox,
  StyledListItemIcon,
  StyledListItemText,
  StyledLogo,
  StyledNavbar,
  StyledWrapper,
} from "./style";
import nativeLogo from "../../assets/images/native-logo.png";
import CustomButton from "../../components/common/button/CustomButton";
import {
  StyledAvatar,
  StyledIcon,
  StyledIconButton,
} from "../../components/common/navbar/style";
import NotificationsIcon from "../../assets/svg/notifications-icon.svg";
import { useIsMobile } from "../../theme";
import { cookie } from "../../cookies/cookies";
import { BubbleChat } from "../../assets/Icons/BubbleChatSide";
import { Dashboard } from "../../assets/Icons/Dashboard";
import { Customer } from "../../assets/Icons/Customer";
import Lockers from "../../assets/Icons/Lockers";
import CheckoutSide from "../../assets/Icons/CheckoutSide";
import { useSelector } from "react-redux";
import { Product } from "../../assets/Icons/Product";
import { Packing } from "../../assets/Icons/Packing";
import { Settings } from "../../assets/Icons/Settings"; //Rishabh : added setting icon for /admin/settings
import { useSocketContext } from "../../socket/socket";

/*  Todo : use in future */
// const bottomItems = [
//   { text: "Settings", icon: <SettingsIcon />, path: "/settings" },
//   { text: "Help center", icon: <HelpIcon />, path: "/help" },
// ];

const Sidebar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const location = useLocation();
  const profileDetails = useSelector((state) => state?.auth?.profileDetails);

  const { socket } = useSocketContext();
  const userType = profileDetails?.user_type || cookie.get("user_type");
  const isAdmin = userType === "admin";
  const isPeronsalShopper = userType === "personal_shopper";

  if (!userType) return null;
  const handleMenuClick = (text, path) => {
    navigate(path);
    if (isMobile) setMobileOpen(false);
  };

  const handleLogOut = () => {
    cookie.remove("token");
    cookie.remove("user_type");
    if (socket) {
      socket.emit("user_offline", { userId: profileDetails?.id });
    }
    navigate("/login");
  };
  const bottomMenuItems = isAdmin
    ? [
        {
          text: "Setting & Master Data",
          icon: (
            <Settings
              color={
                location?.pathname === "/admin/settings" ? "black" : "white"
              }
            />
          ),
          path: "/admin/settings",
        },
        // {
        //   text: "Help center",
        //   icon: (
        //     <Help
        //       color={
        //         location?.pathname === "/admin/help-center" ? "black" : "white"
        //       }
        //     />
        //   ),
        //   path: "/admin/help-center",
        // },
      ]
    : isPeronsalShopper
      ? []
      : [
          // {
          //   text: "Setting",
          //   icon: (
          //     <Settings
          //       color={
          //         location?.pathname === "/dashboard/settings"
          //           ? "black"
          //           : "white"
          //       }
          //     />
          //   ),
          //   path: "/dashboard/settings",
          // },
          // {
          //   text: "Help center",
          //   icon: (
          //     <Help
          //       color={
          //         location?.pathname === "/dashboard/help-center"
          //           ? "black"
          //           : "white"
          //       }
          //     />
          //   ),
          //   path: "/dashboard/help-center",
          // },
        ];
  const topMenuItems = isAdmin
    ? [
        {
          text: "Dashboard",
          icon: (
            <Dashboard
              color={
                location?.pathname === "/admin/dashboard" ? "black" : "white"
              }
            />
          ),
          path: "/admin/dashboard",
        },
        {
          text: "Customer Management",
          icon: (
            <Customer
              color={
                location?.pathname?.startsWith("/admin/customers")
                  ? "black"
                  : "white"
              }
            />
          ),
          path: "/admin/customers",
        },
        {
          text: "Shopper Management",
          icon: (
            <Customer
              color={
                location?.pathname?.startsWith("/admin/shoppers")
                  ? "black"
                  : "white"
              }
            />
          ),
          path: "/admin/shoppers",
        },
        {
          text: "Product Intake",
          icon: (
            <Product
              color={
                location?.pathname === "/admin/products" ? "black" : "white"
              }
            />
          ),
          path: "/admin/products",
        },
        // Todo: If need to use role management then use this
        //  {
        //   text: "Role Management",
        //   icon: (
        //     <RoleManagementIcon
        //       color={
        //         location?.pathname === "/admin/role-management" ? "black" : "white"
        //       }
        //     />
        //   ),
        //   path: "/admin/role-management",
        // },
        {
          text: "Virtual Lockers",
          icon: (
            <Lockers
              color={
                location?.pathname === "/admin/virtual" ||
                location.pathname === "/admin/virtual-lockers"
                  ? "black"
                  : "white"
              }
            />
          ),
          path: "/admin/virtual-lockers",
        },
        {
          text: "Order Management",
          icon: (
            <Packing
              color={
                location?.pathname === "/admin/orders" ||
                location?.pathname?.startsWith("/admin/orders/")
                  ? "black"
                  : "white"
              }
            />
          ),
          path: "/admin/orders",
        },
        // {
        //   text: "Shipping Management",
        //   icon: (
        //     <Shipping
        //       color={
        //         location?.pathname === "/admin/shipping" ? "black" : "white"
        //       }
        //     />
        //   ),
        //   path: "/admin/shipping",
        // },
        // {
        //   text: "Returns & Disposal",
        //   icon: (
        //     <Returns
        //       color={location?.pathname === "/admin/returns" ? "black" : "none"}
        //     />
        //   ),
        //   path: "/admin/returns",
        // },
        // {
        //   text: "Group Cart Monitoring",
        //   icon: (
        //     <BubbleChat
        //       color={location?.pathname === "/admin/group" ? "black" : "white"}
        //     />
        //   ),
        //   path: "/admin/group",
        // },
        {
          text: "Payment Logs",
          icon: (
            <CheckoutSide
              color={
                location?.pathname === "/admin/payment-logs" ? "black" : "white"
              }
            />
          ),
          path: "/admin/payment-logs",
        },
        {
          text: "Audit Logs",
          icon: (
            <BubbleChat
              color={
                location?.pathname === "/admin/audit-log" ? "black" : "white"
              }
            />
          ),
          path: "/admin/audit-log",
        },
        // {
        //   text: "Notifications",
        //   icon: (
        //     <Notifications
        //       color={
        //         location?.pathname === "/admin/notifications" ? "black" : "none"
        //       }
        //     />
        //   ),
        //   path: "/admin/notifications",
        // },
      ]
    : isPeronsalShopper
      ? [
          // {
          //   text: "Product",
          //   icon: (
          //     <Product
          //       color={
          //         location?.pathname === "/personal-shopper" ? "black" : "white"
          //       }
          //     />
          //   ),
          //   path: "/personal-shopper",
          // },
          {
            text: "Product Intake",
            icon: (
              <Packing
                color={
                  location?.pathname?.startsWith("/personal-shopper/products")
                    ? "black"
                    : "white"
                }
              />
            ),
            path: "/personal-shopper/products",
          },
        ]
      : [
          {
            text: "Dashboard",
            icon: (
              <Dashboard
                color={location?.pathname === "/dashboard" ? "black" : "white"}
              />
            ),
            path: "/dashboard",
          },
          {
            text: "Orders",
            icon: (
              <CheckoutSide
                color={
                  location?.pathname === "/dashboard/orders" ||
                  location?.pathname?.startsWith("/dashboard/orders/")
                    ? "black"
                    : "white"
                }
              />
            ),
            path: "/dashboard/orders",
          },
          // {
          //   text: "Virtual Locker",
          //   icon: (
          //     <Lockers
          //       color={
          //         location?.pathname === "/dashboard/locker" ? "black" : "white"
          //       }
          //     />
          //   ),
          //   path: "/dashboard/locker",
          // },
          {
            text: "Virtual Locker",
            icon: (
              <Lockers
                color={
                  location?.pathname === "/dashboard/locker-v2" ||
                  location?.pathname === "/dashboard/locker/item"
                    ? "black"
                    : "white"
                }
              />
            ),
            path: "/dashboard/locker-v2",
          },
          // {
          //   text: "Personal Shopper",
          //   icon: (
          //     <Shopper
          //       color={
          //         location?.pathname === "/dashboard/shopper"
          //           ? "black"
          //           : "white"
          //       }
          //     />
          //   ),
          //   path: "/dashboard/shopper",
          // },
          // {
          //   text: "Group Cart",
          //   icon: (
          //     <BubbleChat
          //       color={
          //         location?.pathname === "/dashboard/cart" ? "black" : "white"
          //       }
          //     />
          //   ),
          //   path: "/dashboard/cart",
          // },
          // {
          //   text: "Payments",
          //   icon: (
          //     <Elements
          //       color={
          //         location?.pathname === "/dashboard/payments"
          //           ? "black"
          //           : "white"
          //       }
          //     />
          //   ),
          //   path: "/dashboard/payments",
          // },
          // {
          //   text: "Returns & Refunds",
          //   icon: (
          //     <Return
          //       color={
          //         location?.pathname === "/dashboard/returns"
          //           ? "black"
          //           : "white"
          //       }
          //     />
          //   ),
          //   path: "/dashboard/returns",
          // },
        ];

  return (
    <>
      {isMobile && (
        <AppBar>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={() => setMobileOpen(true)}
            >
              <MenuIcon />
            </IconButton>
            <StyledNavbar>
              <StyledIcon>
                <StyledIconButton>
                  <img
                    loading="lazy"
                    src={NotificationsIcon}
                    alt="notification Icon"
                  />
                </StyledIconButton>
                <StyledAvatar src={avatarIcon} loading="lazy" />
              </StyledIcon>
            </StyledNavbar>
          </Toolbar>
        </AppBar>
      )}

      <StyledDrawer
        variant={isMobile ? "temporary" : "permanent"}
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
      >
        <StyledWrapper>
          <StyledLogo>
            <img loading="lazy" src={nativeLogo} alt="Logo" />
          </StyledLogo>

          <StyledList menutype="top" isAdmin={isAdmin}>
            {topMenuItems.map((item) => {
              const pathname = location?.pathname || "";
              const isSelected =
                pathname === item?.path ||
                (item?.path === "/personal-shopper/products" &&
                  (pathname === "/personal-shopper/products" ||
                    pathname.startsWith("/personal-shopper/products/") ||
                    pathname.startsWith("/personal-shopper/items/"))) ||
                (item?.path === "/dashboard/locker-v2" &&
                  (pathname === "/dashboard/locker/item" ||
                    pathname.startsWith("/dashboard/items/"))) ||
                (item?.path === "/admin/products" &&
                  pathname.startsWith("/admin/items/")) ||
                (item?.path === "/admin/orders" &&
                  pathname.startsWith("/admin/orders/")) ||
                (item?.path === "/admin/customers" &&
                  pathname.startsWith("/admin/customers/")) ||
                (item?.path === "/admin/shoppers" &&
                  pathname.startsWith("/admin/shoppers/")) ||
                (item?.path === "/dashboard/orders" &&
                  pathname.startsWith("/dashboard/orders/"));

              return (
                <ListItem key={item.text} disablePadding>
                  <StyledListItemButtonBox
                    isselecteditem={isSelected ? 1 : 0}
                    selected={isSelected}
                    onClick={() => handleMenuClick(item.text, item.path)}
                  >
                    <StyledListItemIcon isselecteditem={isSelected ? 1 : 0}>
                      {React.cloneElement(item.icon, {
                        color: isSelected ? "black" : "white",
                      })}
                    </StyledListItemIcon>
                    <StyledListItemText primary={item.text} />
                  </StyledListItemButtonBox>
                </ListItem>
              );
            })}
          </StyledList>
          <StyledList menutype="bottom" isAdmin={isAdmin}>
            {bottomMenuItems.map((item) => {
              const isSelected = location?.pathname === item?.path;

              return (
                <ListItem key={item.text} disablePadding>
                  <StyledListItemButtonBox
                    isselecteditem={isSelected ? 1 : 0}
                    selected={isSelected}
                    onClick={() => handleMenuClick(item.text, item.path)}
                  >
                    <StyledListItemIcon isselecteditem={isSelected ? 1 : 0}>
                      {React.cloneElement(item.icon, { color: isSelected ? "black" : "white" })}
                    </StyledListItemIcon>
                    <StyledListItemText primary={item.text} />
                  </StyledListItemButtonBox>
                </ListItem>
              );
            })}
          </StyledList>
        </StyledWrapper>

        <StyledWrapper ispad={"true"}>
          {/*  Todo : use in future */}
          {/* <List>
            {bottomItems.map((item) => (
              <ListItem key={item.text} disablePadding>
                <StyledListItemButtonBox
                  selectedItem={selectedItem === item.text}
                  onClick={() => handleMenuClick(item.text, item.path)}
                >
                  <StyledListItemIcon selectedItem={selectedItem === item.text}>
                    {item.icon}
                  </StyledListItemIcon>
                  <StyledListItemText primary={item.text} />
                </StyledListItemButtonBox>
              </ListItem>
            ))}
          </List> */}
          <StyledBoxLogOut>
            <CustomButton
              type="submit"
              btnLabel="LOG OUT"
              btntype={"danger"}
              height="40px"
              fullWidth
              startIcon={<LogoutIcon />}
              onClick={handleLogOut}
            />
          </StyledBoxLogOut>
        </StyledWrapper>
      </StyledDrawer>
    </>
  );
};

export default Sidebar;
